import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { Button } from "@aidron/aidron-ds";
import { i18n } from "../../translate/i18n";
import { MyAccountSettingsTab } from "./components/settings.index";
import { Default } from "../../components/Default/Default";
import { PageHeading } from "../../components/StyledComponents/styleComponents.index";
import { SETTINGS_ROUTES, useSeetingsViewModel } from "../../viewModel/useSettingsViewModel";
import { UsersManagement } from "./components/UsersManagement/UserManagement";
import { USER_ROLES } from "../../components/components.constants";

export const Settings = () => {
    const { t } = i18n;
    const vm = useSeetingsViewModel({ shouldFetchUserCtx: true });
    const navigate = useNavigate();

    return (
      <Default>
        <PageHeading>{t("settings")}</PageHeading>
        <div className="border-bottom-orange d-flex mt-4">
          {vm.ctx.tabs.map((tab) => (
            <Button
              key={tab.name}
              label={i18n.t(tab.name)}
              onClick={() => navigate(`/configuracoes/${tab.route}`)}
              type="outlined"
              className="border-radius-15px-150px-0-0 box-shadow-black-2--2-5-0 box-shadow-black-1--3-6-on-button-hover border-bottom-0 ms-3"/>
          ))}
        </div>
        <Routes>
            <Route index element={<Navigate to="conta" replace />} />
            <Route path="conta" element={<MyAccountSettingsTab />} />
            {(vm.ctx.userRole === USER_ROLES.TENANT_ADMIN || vm.ctx.userRole === USER_ROLES.ADMIN) && (
                <Route path="usuarios" element={<UsersManagement />} />
            )}
        </Routes>
      </Default>
    );
}